export const UPDATE_LAST_CHECKED_ALERTS_MUTATION = `
  mutation UpdateLastCheckedAlerts {
    me {
      updateLastCheckedAlerts
    }
  }
`;
